import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    ViewEncapsulation,
} from '@angular/core';

// TODO modify cmps-tooltip in uikit to have this as an option
@Component({
    selector: 'cmps-ts-tooltip-conditional',
    template: ` <ng-container *ngIf="_show">
            <ng-content select="show"></ng-content>
        </ng-container>
        <ng-container *ngIf="!_show">
            <ng-content select="no-show"></ng-content>
        </ng-container>`,
    host: {
        '(mouseenter)': '_onMouseEnterLeave()',
        '(mouseleave)': '_onMouseEnterLeave()',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class TooltipConditionalDirective {
    @Input() selector: string;

    /** @private */
    _show: boolean;

    constructor(
        private readonly _el: ElementRef<HTMLElement>,
        private readonly _changeDetectorRef: ChangeDetectorRef,
    ) {}

    /** @private */
    _onMouseEnterLeave(): void {
        const el: HTMLElement = this._el.nativeElement.querySelector(
            this.selector,
        );
        if (el == null) {
            this._show = false;
            return;
        }
        this._show =
            el.offsetWidth < el.scrollWidth ||
            el.offsetHeight < el.scrollHeight;
        this._changeDetectorRef.markForCheck();
    }
}
